define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var userValidationConfig = require('modules/user/user.validation.config');
    var BaseModel = require('common/base.model');
    var server = require('server');
    var i18n = require('i18n');

    module.exports = BaseModel.extend({

        validationConfig: function() {
            return _.extend(userValidationConfig(), {
                cardNumber: {
                    required: true,
                    length: {
                        min: 13,
                        max: 19,
                        message: i18n.t('playtech.mobile.system.mobile-cashier.tooltip.cardNumber.invalid')
                    },
                    regexp: {
                        regexp: /^$|^\d+$/,
                        message: i18n.t('playtech.mobile.system.mobile-cashier.tooltip.cardNumber.regexp')
                    }
                },
                expirationDate: {
                    required: true,
                    fn: {
                        fn: function($inputs, config, form) {
                            var month = Number(form.data('month')),
                                year = Number(form.data('expirationYear')),
                                curDate = new Date();

                            return !(year === curDate.getFullYear() && month < curDate.getMonth() + 1);
                        },
                        message: i18n.t('playtech.mobile.system.mobile-cashier.add-card.error.expiration-date-invalid')
                    }
                },
                alias: {
                    require: false,
                    length: {
                        min: 0,
                        max: 20,
                        message: i18n.t('playtech.mobile.system.mobile-cashier.alias.length')
                    }
                }
            });
        },

        addCard: function(data) {
            return server.send({
                ID: 33054,
                description: 'Create Payment Account',
                responses: [33055, 33056],
                specificParams: _.chain(data)
                    .extend({expirationDate: data.expirationYear + '-' + data.month})
                    .omit(['expirationYear', 'month', 'fillUserData'])
                    .value()
            });
        }

    });

});
